import { useState } from "react";
import styles from "./SettingsPage.module.css";

import Header from "../../components/Header";
import SettingsSidebar from "../../components/settings/SettingsSidebar";
import TermsPrivacySection from "../../components/settings/TermsPrivacySection";
import AccountSection from "../../components/settings/AccountSection";
import PrivacySection from "../../components/settings/PrivacySection";
import SecuritySection from "../../components/settings/SecuritySection";
import NotificationsSection from "../../components/settings/NotificationsSection";
import DisplaySection from "../../components/settings/DisplaySection";
import FeedbackSection from '../../components/settings/FeedbackSection';

const SECTIONS = {
  account: AccountSection,
  privacy: PrivacySection,
  security: SecuritySection,
  notifications: NotificationsSection,
  display: DisplaySection,
   feedback: FeedbackSection,
   termsPrivacy: TermsPrivacySection,
};

export default function SettingsPage() {
  const [activeSection, setActiveSection] = useState("account");

  const ActiveComponent =
  SECTIONS[activeSection] || AccountSection;

  return (
    <div className={styles.wrapper}>
      <Header />

      <div className={styles.layout}>
        <SettingsSidebar
          activeSection={activeSection}
          onSelect={setActiveSection}
        />

        <div
className={styles.content}
key={activeSection}
>
          <ActiveComponent />
        </div>
      </div>
    </div>
  );
}